import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDataFetcher } from '../../../hooks';
import { Container } from 'react-bootstrap';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import ErrorList from '../../../errorList';
import { Form, FormHeading, Well } from '../../../form';
import VisitorAgreementDetailsForm from '../form';
import { IEditVisitorAgreementPageRouteParams } from './types';
import updateVisitorAgreement from './updateVisitorAgreement';
import deleteVisitorAgreement from './deleteVisitorAgreement';
import schema from '../form/schema';
import {
  NotificationModal,
  ConfirmationModal,
  useModal,
  INotificationModalProps,
  IConfirmationModalProps,
} from '../../../modals';
import { IApiError } from '../../../../services';

export const EditVisitorAgreementPage: React.FC = () => {
  const history = useHistory();
  const { showModal, hideModal } = useModal();

  const { id } = useParams<IEditVisitorAgreementPageRouteParams>();

  const [deleteErrors, setDeleteErrors] = useState<Array<string>>([]);

  const { busy, errors: fetchErrors, data: agreement } = useDataFetcher(
    `api/visitorAgreements/${id}`,
  );

  const handleDelete = () => {
    const confirmationProps: IConfirmationModalProps = {
      title: 'Delete Visitor Agreement',
      message:
        'Are you sure that you to permanently delete this visitor agreement?',
      icon: ['far', 'question-circle'],
      kind: 'danger',
      onConfirmed: () => {
        hideModal();

        deleteVisitorAgreement(+id)
          .then(() => history.replace('/admin/visitorAgreements'))
          .catch((error: IApiError) => {
            if (error && error.errorNumber === 1006) {
              const props: INotificationModalProps = {
                title: 'Unable to delete Visitor Agreement',
                message:
                  'This visitor agreement cannot be deleted because it is being used by one or more sites.',
                icon: ['far', 'info-circle'],
                kind: 'info',
                onRequestClose: () => {
                  hideModal();
                },
              };

              showModal(NotificationModal, props);
            } else {
              setDeleteErrors(error.messages);
            }
          });
      },
      onRequestClose: () => hideModal(),
    };

    showModal(ConfirmationModal, confirmationProps);
  };

  return (
    <Container fluid>
      <Well>
        <FormHeading
          title="Visitor Agreement"
          subTitle="Edit"
          backPath="/admin/visitorAgreements"
        />
        <AjaxErrorBoundary
          busy={busy}
          loadingText={`Loading visitor agreement`}
          errors={fetchErrors}
        >
          <ErrorList errors={deleteErrors} />
          <Form
            initialValues={agreement}
            promise={updateVisitorAgreement}
            validationSchema={schema}
            onSubmit={() => history.push('/admin/visitorAgreements')}
          >
            <VisitorAgreementDetailsForm onDelete={handleDelete} />
          </Form>
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};
